export const COLORS = {
    primary: '#1E88E5', // Primary Blue
    background: '#1B1E23', // Dark Background
    surface: '#262A34', // Card and Form Background
    textPrimary: '#FFFFFF', // White Text
    textSecondary: '#B0BEC5', // Grey Text
    error: '#FF5252', // Error Red
    inputBackground: '#2C303A', // Input Field Background
    inputText: '#FFFFFF', // Input Text
    inputPlaceholder: '#9E9E9E', // Input Placeholder
  };
  